import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { assocPath, compose, path } from 'ramda';
import { asyncConnect } from 'react-async-client';
import { Button } from 'antd';
import Translate from 'react-translate-component';

import { getScript, putDocumentText } from 'actions/asyncActions';
import { openModalEventScript } from 'actions/modalActions';
import ErrorHTML from 'components/common/form/ErrorHTML';
import SpinCenter from 'components/common/SpinCenter';

@asyncConnect(props => ({
    getScript: getScript
        .withPayload(path(['event', 'id']))
        .withOptions({ dispatchOnMount: !!path(['event', 'id'], props), autoReset: true }),
    putDocumentText: putDocumentText
        .withSuccessHandler(({ close }) => close())
        .withOptions({ resetOnUnmount: true })
}), null, {
    openModalEventScript,
})
export default class DocumentEditScript extends Component {
    static propTypes = {
        getScript: PropTypes.object.isRequired,
        putDocumentText: PropTypes.object.isRequired,
        document: PropTypes.object.isRequired,
        event: PropTypes.object.isRequired,
        body: PropTypes.object.isRequired,
        footer: PropTypes.func.isRequired,
        close: PropTypes.func.isRequired,
        openModalEventScript: PropTypes.func.isRequired,
    };

    getScript = script => compose(
        this.getScriptEditable,
        this.addScriptScales,
    )(script)

    getScriptEditable = compose(
        assocPath(['answers', 'freeze'], false),
        assocPath(['options', 'view_mode'], false)
    )

    addScriptScales = script => compose(
        assocPath(['scales'], path(['preview', 'body', 'scales'], this.props.getScript.data)
            || path(['scales'], script)
            || []
        )
    )(script)

    saveDocument = (values) => {
        const { document } = this.props;

        this.props.putDocumentText.dispatch({
            id: document.id,
            fileType: document.fileType,
            result: {
                body: JSON.stringify(values),
            }
        })
    }

    render() {
        const { body, getScript: { meta: scriptMeta }, close, openModalEventScript } = this.props;
        const { meta } = this.props.putDocumentText;

        return (
            <Fragment>
                { meta.error && <ErrorHTML meta={meta} /> }
                { scriptMeta.pending && <SpinCenter /> }
                { scriptMeta.error && <ErrorHTML meta={scriptMeta} /> }
                { scriptMeta.success && (
                    <div className="text-center">
                        <Button
                            className='card-button'
                            type='primary'
                            onClick={() => openModalEventScript({
                                body: this.getScript(body),
                                onComplete: this.saveDocument,
                            })}
                        >
                            <Translate content="events.formDocumentEdit" />
                        </Button>
                        <Button className='card-button' onClick={close}>
                            <Translate content="events.formDocumentEditCancel" />
                        </Button>
                    </div>
                )}
            </Fragment>
        );
    }
}
